// src/pages/Maintenance.jsx
import React from "react";

const Maintenance = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="maintenance-page">
      <style>{`
        :root {
          color-scheme: light;
        }

        * {
          box-sizing: border-box;
        }

        html,
        body,
        #root {
          min-height: 100%;
        }

        body {
          margin: 0;
          overflow-x: hidden;
          background: #f5f7fb;
        }

        .maintenance-page {
          position: relative;
          min-height: 100vh;
          min-height: 100dvh;
          width: 100%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 32px;
          background:
            radial-gradient(circle at 12% 15%, rgba(30, 42, 120, 0.12), transparent 34%),
            radial-gradient(circle at 88% 82%, rgba(37, 99, 235, 0.10), transparent 32%),
            linear-gradient(145deg, #f8faff 0%, #f4f6fb 48%, #eef2f9 100%);
          font-family:
            Inter,
            ui-sans-serif,
            -apple-system,
            BlinkMacSystemFont,
            "Segoe UI",
            sans-serif;
          color: #0f172a;
        }

        .maintenance-glow {
          position: absolute;
          border-radius: 999px;
          filter: blur(2px);
          pointer-events: none;
        }

        .maintenance-glow-one {
          top: -160px;
          left: -130px;
          width: 360px;
          height: 360px;
          background: rgba(30, 42, 120, 0.08);
        }

        .maintenance-glow-two {
          right: -140px;
          bottom: -170px;
          width: 400px;
          height: 400px;
          background: rgba(37, 99, 235, 0.07);
        }

        .maintenance-shell {
          position: relative;
          z-index: 1;
          width: 100%;
          max-width: 1040px;
          min-width: 0;
        }

        .maintenance-brand {
          width: 100%;
          min-width: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          margin: 0 0 16px;
          padding: 13px 18px;
          border: 1px solid rgba(255, 255, 255, 0.14);
          border-radius: 18px;
          background: linear-gradient(180deg, #17245F 0%, #1E2A78 58%, #111A44 100%);
          box-shadow: 0 14px 34px rgba(30, 42, 120, 0.22);
          backdrop-filter: blur(14px);
        }

        .maintenance-brand-logo {
          display: block;
          width: 160px;
          max-width: 55%;
          height: auto;
          object-fit: contain;
          filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.16));
        }

        .maintenance-brand-status {
          max-width: 100%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 9px;
          padding: 9px 13px;
          border: 1px solid rgba(255, 255, 255, 0.28);
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.12);
          color: #ffffff;
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.14);
          font-size: 11px;
          line-height: 1;
          font-weight: 900;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          white-space: nowrap;
        }

        .maintenance-card {
          width: 100%;
          min-width: 0;
          overflow: hidden;
          display: grid;
          grid-template-columns: minmax(0, 1.2fr) minmax(280px, 0.8fr);
          border: 1px solid rgba(15, 23, 42, 0.09);
          border-radius: 28px;
          background: rgba(255, 255, 255, 0.94);
          box-shadow:
            0 30px 80px rgba(15, 23, 42, 0.12),
            0 8px 24px rgba(30, 42, 120, 0.06);
          backdrop-filter: blur(16px);
        }

        .maintenance-content {
          min-width: 0;
          padding: 54px 52px 50px;
        }

        .maintenance-live-dot {
          width: 8px;
          height: 8px;
          flex: 0 0 8px;
          border-radius: 999px;
          background: #93C5FD;
          box-shadow:
            0 0 0 5px rgba(255, 255, 255, 0.12),
            0 0 14px rgba(147, 197, 253, 0.9);
          animation: maintenancePulse 1.8s ease-in-out infinite;
        }

        .maintenance-title {
          max-width: 620px;
          margin: 0;
          color: #0f172a;
          font-size: 30px;
          line-height: 1.2;
          font-weight: 950;
          letter-spacing: -0.75px;
          overflow-wrap: anywhere;
        }

        .maintenance-title-accent {
          color: #1e2a78;
        }

        .maintenance-subtitle {
          max-width: 610px;
          margin: 22px 0 0;
          color: #475569;
          font-size: 17px;
          line-height: 1.72;
          font-weight: 600;
          overflow-wrap: anywhere;
        }

        .maintenance-actions {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 30px;
        }

        .maintenance-button,
        .maintenance-support-email {
          min-height: 46px;
          max-width: 100%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 9px;
          border-radius: 13px;
          padding: 12px 17px;
          font: inherit;
          font-size: 14px;
          line-height: 1.2;
          font-weight: 850;
          text-decoration: none;
        }

        .maintenance-button {
          cursor: pointer;
          transition:
            transform 160ms ease,
            box-shadow 160ms ease,
            background 160ms ease,
            border-color 160ms ease;
        }

        .maintenance-button {
          border: 1px solid #1e2a78;
          background: #1e2a78;
          color: #ffffff;
          box-shadow: 0 10px 22px rgba(30, 42, 120, 0.22);
        }

        .maintenance-support-email {
          border: 1px solid rgba(15, 23, 42, 0.12);
          background: #ffffff;
          color: #1e2a78;
          cursor: default;
          overflow-wrap: anywhere;
          user-select: text;
        }

        .maintenance-button:hover {
          transform: translateY(-1px);
        }

        .maintenance-button:focus-visible {
          outline: 3px solid rgba(37, 99, 235, 0.26);
          outline-offset: 3px;
        }

        .maintenance-note {
          display: flex;
          align-items: flex-start;
          gap: 11px;
          margin: 30px 0 0;
          padding: 15px 16px;
          border: 1px solid rgba(15, 23, 42, 0.08);
          border-radius: 15px;
          background: #f8fafc;
          color: #475569;
          font-size: 13.5px;
          line-height: 1.55;
          font-weight: 650;
        }

        .maintenance-note svg {
          flex: 0 0 auto;
          margin-top: 1px;
          color: #2563eb;
        }

        .maintenance-side {
          position: relative;
          min-width: 0;
          display: flex;
          align-items: stretch;
          padding: 22px;
          background: linear-gradient(
            180deg,
            #17245F 0%,
            #1E2A78 58%,
            #111A44 100%
          );
        }

        .maintenance-status-panel {
          position: relative;
          width: 100%;
          min-width: 0;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 28px;
          border: 1px solid rgba(255, 255, 255, 0.30);
          border-radius: 22px;
          background: rgba(255, 255, 255, 0.12);
          box-shadow:
            inset 0 1px 0 rgba(255, 255, 255, 0.22),
            0 18px 42px rgba(2, 6, 23, 0.22);
          backdrop-filter: blur(18px) saturate(135%);
          -webkit-backdrop-filter: blur(18px) saturate(135%);
          color: #ffffff;
        }

        .maintenance-status-panel::before {
          content: "";
          position: absolute;
          inset: 0;
          pointer-events: none;
          background:
            linear-gradient(
              145deg,
              rgba(255, 255, 255, 0.16) 0%,
              rgba(255, 255, 255, 0.04) 42%,
              rgba(255, 255, 255, 0.08) 100%
            );
        }

        .maintenance-status-panel > * {
          position: relative;
          z-index: 1;
        }

        .maintenance-status-icon {
          width: 68px;
          height: 68px;
          display: grid;
          place-items: center;
          border: 1px solid rgba(255, 255, 255, 0.18);
          border-radius: 20px;
          background: rgba(255, 255, 255, 0.14);
          box-shadow: 0 18px 40px rgba(15, 23, 42, 0.18);
        }

        .maintenance-status-icon svg {
          transform-origin: center;
          animation: maintenanceGearSpin 8s linear infinite;
        }

        .maintenance-status-label {
          margin: 28px 0 7px;
          color: rgba(255, 255, 255, 0.72);
          font-size: 11px;
          line-height: 1.2;
          font-weight: 900;
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }

        .maintenance-status-title {
          margin: 0;
          color: #ffffff;
          font-size: clamp(17px, 2vw, 22px);
          line-height: 1.2;
          font-weight: 900;
          letter-spacing: -0.45px;
          white-space: nowrap;
        }

        .maintenance-status-text {
          margin: 10px 0 0;
          color: rgba(255, 255, 255, 0.78);
          font-size: 14px;
          line-height: 1.6;
          font-weight: 600;
        }

        .maintenance-progress {
          margin-top: 34px;
        }

        .maintenance-progress-row {
          display: flex;
          justify-content: space-between;
          gap: 12px;
          margin-bottom: 9px;
          color: rgba(255, 255, 255, 0.78);
          font-size: 11px;
          line-height: 1.2;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.06em;
        }

        .maintenance-progress-track {
          height: 8px;
          overflow: hidden;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.18);
        }

        .maintenance-progress-bar {
          width: 42%;
          height: 100%;
          border-radius: 999px;
          background: #ffffff;
          animation: maintenanceProgress 2.4s ease-in-out infinite alternate;
        }

        .maintenance-safe-card {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          margin-top: 34px;
          padding: 15px;
          border: 1px solid rgba(255, 255, 255, 0.14);
          border-radius: 16px;
          background: rgba(15, 23, 42, 0.12);
        }

        .maintenance-safe-card svg {
          flex: 0 0 auto;
          margin-top: 1px;
        }

        .maintenance-safe-title {
          margin: 0;
          color: #ffffff;
          font-size: 13px;
          line-height: 1.35;
          font-weight: 900;
        }

        .maintenance-safe-text {
          margin: 4px 0 0;
          color: rgba(255, 255, 255, 0.74);
          font-size: 12px;
          line-height: 1.5;
          font-weight: 600;
        }

        .maintenance-footer {
          margin: 16px 4px 0;
          color: #64748b;
          font-size: 12px;
          line-height: 1.5;
          font-weight: 650;
          text-align: center;
        }

        @keyframes maintenancePulse {
          0%,
          100% {
            opacity: 1;
            transform: scale(1);
          }

          50% {
            opacity: 0.55;
            transform: scale(0.84);
          }
        }

        @keyframes maintenanceProgress {
          0% {
            width: 28%;
            transform: translateX(0);
          }

          100% {
            width: 58%;
            transform: translateX(68%);
          }
        }

        @keyframes maintenanceGearSpin {
          from {
            transform: rotate(0deg);
          }

          to {
            transform: rotate(360deg);
          }
        }

        @media (max-width: 1023px) {
          .maintenance-page {
            align-items: flex-start;
            padding: 22px 16px 34px;
          }

          .maintenance-shell {
            max-width: 760px;
          }

          .maintenance-brand {
            margin-left: 0;
            justify-content: center;
            flex-wrap: wrap;
            text-align: center;
          }

          .maintenance-brand-logo {
            margin: 0 auto;
          }

          .maintenance-title {
            max-width: none;
            width: 100%;
            margin-left: auto;
            margin-right: auto;
            font-size: clamp(23px, 4vw, 28px);
            line-height: 1.2;
            letter-spacing: -0.6px;
            text-align: center;
            white-space: nowrap;
          }

          .maintenance-card {
            grid-template-columns: 1fr;
            border-radius: 24px;
          }

          .maintenance-content {
            padding: 40px 30px 34px;
          }

          .maintenance-side {
            padding: 18px;
            background: linear-gradient(
              180deg,
              #17245F 0%,
              #1E2A78 58%,
              #111A44 100%
            );
          }

          .maintenance-status-panel {
            padding: 24px;
            border-color: rgba(255, 255, 255, 0.34);
            background: rgba(255, 255, 255, 0.14);
            box-shadow:
              inset 0 1px 0 rgba(255, 255, 255, 0.24),
              0 16px 36px rgba(2, 6, 23, 0.24);
          }

        }

        @media (max-width: 600px) {
          .maintenance-page {
            padding: 16px 12px 26px;
          }

          .maintenance-brand {
            gap: 10px;
            margin-bottom: 12px;
            padding: 12px;
            border-radius: 15px;
          }

          .maintenance-brand-logo {
            width: 150px;
            max-width: 78%;
          }

          .maintenance-brand-status {
            gap: 7px;
            padding: 8px 10px;
            font-size: 9px;
            letter-spacing: 0.03em;
          }

          .maintenance-card {
            border-radius: 20px;
          }

          .maintenance-content {
            padding: 32px 20px 28px;
          }

          .maintenance-subtitle {
            margin-top: 17px;
            font-size: 15px;
            line-height: 1.65;
          }

          .maintenance-actions {
            display: grid;
            grid-template-columns: 1fr;
            margin-top: 24px;
          }

          .maintenance-button,
          .maintenance-support-email {
            width: 100%;
          }

          .maintenance-note {
            margin-top: 24px;
          }

          .maintenance-side {
            padding: 12px;
          }

          .maintenance-status-panel {
            padding: 21px;
            border-radius: 17px;
            border-color: rgba(255, 255, 255, 0.36);
            background: rgba(255, 255, 255, 0.15);
          }

          .maintenance-status-icon {
            width: 58px;
            height: 58px;
            border-radius: 17px;
          }

          .maintenance-status-title {
            font-size: 21px;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .maintenance-live-dot,
          .maintenance-progress-bar,
          .maintenance-status-icon svg {
            animation: none;
          }

          .maintenance-button {
            transition: none;
          }
        }
      `}</style>

      <div className="maintenance-glow maintenance-glow-one" aria-hidden="true" />
      <div className="maintenance-glow maintenance-glow-two" aria-hidden="true" />

      <div className="maintenance-shell">
        <header className="maintenance-brand">
          <img
            src={`${process.env.PUBLIC_URL}/assets/logo-full.png`}
            alt="AskLawly"
            className="maintenance-brand-logo"
          />

          <div className="maintenance-brand-status">
            <span className="maintenance-live-dot" aria-hidden="true" />
            Scheduled maintenance
          </div>
        </header>

        <main
          className="maintenance-card"
          role="status"
          aria-live="polite"
          aria-label="AskLawly maintenance status"
        >
          <section className="maintenance-content">
            <h1 className="maintenance-title">
              We’re making AskLawly{" "}
              <span className="maintenance-title-accent">better.</span>
            </h1>

            <p className="maintenance-subtitle">
              AskLawly is temporarily unavailable while we complete important
              system updates. No action is required from you. Please check back
              shortly.
            </p>

            <div className="maintenance-actions">
              <button
                type="button"
                className="maintenance-button"
                onClick={handleRefresh}
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M20 11a8 8 0 1 0-2.34 5.66M20 4v7h-7"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Try again
              </button>

              <div
                className="maintenance-support-email"
                aria-label="AskLawly support email"
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M4 6.5h16v11H4v-11Zm0 .5 8 6 8-6"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                support@asklawly.com
              </div>
            </div>

            <div className="maintenance-note">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-12v6m0-9.01V6"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
              </svg>

              <span>
                You may safely close this page and return later. Access will be
                restored as soon as maintenance is complete.
              </span>
            </div>
          </section>

          <aside className="maintenance-side" aria-label="System update status">
            <div className="maintenance-status-panel">
              <div>
                <div className="maintenance-status-icon" aria-hidden="true">
                  <svg
                    width="34"
                    height="34"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M12 15.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Zm7.25-3.25c0-.54-.06-1.07-.17-1.57l2.02-1.57-2-3.46-2.49 1a7.8 7.8 0 0 0-2.72-1.57L13.5 2h-4l-.39 2.84A7.8 7.8 0 0 0 6.39 6.4l-2.49-1-2 3.46 2.02 1.57A7.4 7.4 0 0 0 3.75 12c0 .54.06 1.07.17 1.57L1.9 15.14l2 3.46 2.49-1a7.8 7.8 0 0 0 2.72 1.57L9.5 22h4l.39-2.84a7.8 7.8 0 0 0 2.72-1.57l2.49 1 2-3.46-2.02-1.57c.11-.5.17-1.03.17-1.57Z"
                      stroke="currentColor"
                      strokeWidth="1.45"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <p className="maintenance-status-label">Current status</p>
                <h2 className="maintenance-status-title">
                  System updates in progress
                </h2>
                <p className="maintenance-status-text">
                  Our team is completing maintenance and validating service
                  availability before reopening access.
                </p>

                <div className="maintenance-progress" aria-hidden="true">
                  <div className="maintenance-progress-row">
                    <span>Updating services</span>
                    <span>In progress</span>
                  </div>
                  <div className="maintenance-progress-track">
                    <div className="maintenance-progress-bar" />
                  </div>
                </div>
              </div>

              <div className="maintenance-safe-card">
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M12 3 5 6v5c0 4.75 2.85 8.15 7 10 4.15-1.85 7-5.25 7-10V6l-7-3Zm-3 9 2 2 4-4"
                    stroke="currentColor"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <div>
                  <p className="maintenance-safe-title">Your data remains safe</p>
                  <p className="maintenance-safe-text">
                    Your account information and saved activity remain protected
                    during maintenance.
                  </p>
                </div>
              </div>
            </div>
          </aside>
        </main>

        <footer className="maintenance-footer">
          © {new Date().getFullYear()} AskLawly. All rights reserved.
        </footer>
      </div>
    </div>
  );
};

export default Maintenance;
